export const ASSOCIATE_NAME = "John Jones";
export const CUSTOMER_ENROLL_URL = "https://start.myeliteassociates.com/m/132404534";
export const PARTNER_ENROLL_URL = "https://start.myeliteassociates.com/r/132404534";
export const REDIRECT_URL = "https://start.myeliteassociates.com/r/132404534";
